import { type FC } from 'react';
import {
	ToolNavigationButton,
} from '../../../../../ReactSharedScripts/modules/toolNavigation/components/ToolNavigationButton';
import { ThemeStyle } from '../../../../../ReactSharedScripts/utils/const';
import { gray } from '../../../../../ReactSharedScripts/components/Color';
import { useStyleContextState } from '../../../../../ReactSharedScripts/modules/styleContext';
import classes from '../styles/index.module.css';
import { useToolNavigationExpandedProvider } from './ToolNavigationExpandedProvider';

export const ToolNavigationHeader: FC = () => {
	const { theme } = useStyleContextState();
	const { toggleExpanded } = useToolNavigationExpandedProvider();

	return (
		<div className={classes.toolNavigation__topSection}>
			<ToolNavigationButton
				onClick={() => toggleExpanded()}
				fill={theme === ThemeStyle.Dark ? gray[2] : gray[8]}
			/>
		</div>
	);
};
